import { render, staticRenderFns } from "./SummaryListItem.vue?vue&type=template&id=5925fb8e&"
import script from "./SummaryListItem.vue?vue&type=script&lang=ts&"
export * from "./SummaryListItem.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports